<script>
export default {
  props: {
    markSsrOnly: {
      type: Function,
      default: null,
    },
  },
  created() {
    if (IS_SSR) {
      this.onCreatedMarkAsSsrOnly();
    }
  },
  methods: {
    onCreatedMarkAsSsrOnly() {
      if (IS_SSR && this.markSsrOnly) {
        this.markSsrOnly();
      }
    },
  },
};
</script>
